import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import errors from './Errors/errors';
import {validateValue} from './../../../utilities/validation/validator';
import {validationRules} from './../../../utilities/validation/validationVariables';
import AuthenticationProvider from './../../../utilities/authentication/authenticationProvider';
import {stepEnum, packageSelectionStatus, magicLinkReponse} from './ChangePricePlanConsts';
import {GetOrganizationDataFromEpi} from '../FamilyMemberCellularSaleBlock/familyMemberCellularSaleSlice';
import {refreshToken} from 'app/utilities/authentication/authenticationSlice';
import {createReportUpdateCellularPlan} from 'app/utilities/reports/createReport';
import EpiContext from '@episerver/spa-core/Spa';

export const getCustomerCellularList = createAsyncThunk('changePricePlan/getCustomerCellularList', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getCustomerCellularList', []);
    return {data: result.Body, serverError: false};
  } catch (error) {
    return {serverError: true};
  }
});

export const validateAndSendMagicLink = createAsyncThunk('changePricePlan/validateAndSendMagicLink', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('validateAndSendMagicLink', [data.subscriber, data.link]);
    return {data: result.Body, serverError: false};
  } catch (error) {
    return {serverError: true};
  }
});

export const checkIfExistsInFather = createAsyncThunk('changePricePlan/checkIfExistsInFather', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('checkIfExistsInFather', [data.subscriberNo]);
    return {data: result.Body, serverError: false};
  } catch (error) {
    return {serverError: true};
  }
});

export const getCurrentCellularPricePlan = createAsyncThunk('changePricePlan/getCurrentCellularPricePlan', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getCurrentCellularPricePlan', [data.subscriberNo, data.ban]);
    return {data: result.Body, serverError: false};
  } catch (error) {
    return {serverError: true};
  }
});

export const getFuturePlan = createAsyncThunk('changePricePlan/getFuturePlan', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getFuturePlan', [data.subscriberNo, data.ban]);
    return {data: result.Body, serverError: false};
  } catch (error) {
    return {serverError: true};
  }
});

export const doCallBack = createAsyncThunk('changePricePlan/doCallBack', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('doCallBackToAuthorized', [data.id, data.phone, data.subject]);
    return {isSuccess: result.Body.isSuccess, callBackAlreadyExist: false};
  } catch (error) {
    if (error && error.errorCode == '3') {
      return {isSuccess: true, callBackAlreadyExist: true};
    }
    return {isSuccess: false, callBackAlreadyExist: false};
  }
});

export const sendRequestChangingCellularPackage = createAsyncThunk(
  'changePricePlan/sendRequestChangingCellularPackage',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('sendRequestChangePricePlan', [
        data.sendingMethod,
        data.contactDestination,
        data.otpPhoneNumber,
        data.ban,
        data.subscribers,
        data.collaborationApproval,
        data.agreeReceiveReceiptToMail,
        data.isImmediateTransitionPlan,
      ]);
      if (result.Body.isSuccessed) {
        await thunkAPI.dispatch(refreshToken());
      }
      const userData = thunkAPI.getState().authentication.loginData.userDetails;
      return {data: result.Body, serverError: false, userData: userData};
    } catch (error) {
      return {serverError: true};
    }
  },
);

export const getSelectedSubscriberDetails = createAsyncThunk('changePricePlan/getSelectedSubscriberDetails', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getSelectedSubscriberDetails', [data.subscriberNo, data.ban]);
    return {data: result.Body, selectedAccount: data, serverError: false};
  } catch (error) {
    return {serverError: true};
  }
});

export const IsCellcomNumber = createAsyncThunk('changePricePlan/IsCellcomNumber', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('IsCellcomNumber', [data.phoneNumber]);
    return result.Body;
  } catch (error) {
    return error;
  }
});

const initialPhoneForm = {
  label: 'לנייד ב-SMS',
  phone: '',
  preText: 'SMS למספר',
  placeholder: 'SMS לנייד',
  errors: {},
  rules: {
    phone: validationRules.phone,
  },
};
const initialEmailForm = {
  label: 'למייל',
  email: '',
  preText: 'מייל',
  placeholder: 'מייל',
  errors: {},
  rules: {
    email: validationRules.email,
  },
};

const initialState = {
  isLoading: false,
  error: false,
  callbackRequest: false,
  callBackRequestFailed: false,
  callBackRequestSent: false,
  callBackAlreadyExist: false,
  errorData: null,
  errorReason: '',
  errorStep: '',
  currentStep: '',
  activeAccount: null,
  warningConfirmed: false,
  collaborationApproval: false,
  showSignCollaboration: false,
  showInvoiceByEmail: false,
  selectedForm: 'phone',
  form: {
    phone: initialPhoneForm,
    email: initialEmailForm,
  },
  callBackPhone: {
    phone: '',
    errors: {},
    rules: {
      phone: validationRules.phone,
      landPhone: validationRules.phoneStationaryAccepted,
    },
  },
  headlineText: null,
  allCellularPackagesForAccountData: null,
  selectedAccount: null,
  selectedAccountExtendedData: null,
  getSelectedSubscriberDetailsCompleted: false,
  selectCellularPackageProcess: {
    status: packageSelectionStatus.SELECTING,
  },
  discountedPackages: null,
  packagesList: null,
  currentCellularPlan: '',
  failReasonCode: '',
  succeededNumbers: null,
  unSucceededNumbers: null,
  familyBalance: 0,
  familyUsed: 0,
  completed: false,
  selectedMarketPackage: null,
  magicLinkStatus: null,
  isOwnerChanged: false,
  magicLinkRes: null,
  magicLinkOrgData: null,
  magicLinkPackList: null,
  showThirdPartyPopup: false,
  activateTransitionAnimation: false,
};

const changePricePlanSlice = createSlice({
  name: 'changePricePlan',
  initialState: initialState,
  reducers: {
    resetState: (state) => initialState,
    logoutOtp: (state, action) => {
      AuthenticationProvider.clearAuthenticationData();
      state.error = false;
      state.selectedAccount = null;
      state.selectedAccountExtendedData = null;
      state.getSelectedSubscriberDetailsCompleted = false;
      state.allCellularPackagesForAccountData = null;
      state.showThirdPartyPopup = false;
      state.magicLinkRes = null;
      state.magicLinkStatus = null;
      return state;
    },
    mapUserPhoneNumber: (state, action) => {
      state.callBackPhone.phone = action.payload;
      //validate Mobile
      if (!validateValue(validationRules.phone, 'phone', action.payload)) {
        state.form.phone.phone = action.payload;
        state.form.phone.valid = true;
      }

      return state;
    },
    setError: (state, action) => {
      state.errorData = action.payload.text;
      state.error = true;
      state.errorReason = action.payload.reason;
      return state;
    },
    handleCurrentStep: (state, action) => {
      state.currentStep = action.payload.step;
      state.error = action.payload.error;
      state.stepData = action.payload.data;
      state.completed = false;
      return state;
    },
    setHeadlineText: (state, action) => {
      state.headlineText = action.payload;
      return state;
    },
    setWarningConfirmation: (state, action) => {
      state.warningConfirmed = action.payload;
      return state;
    },
    saveToHistory: (state, action) => {
      return state;
    },
    clearHistory: (state, action) => {
      return state;
    },
    setAccountDataWithNewSelectedPackage: (state, action) => {
      state.selectedAccount.newPackage = action.payload.newPackage;
      state.selectedAccount.checked = false;
      return state;
    },
    saveSelectedDataForFixedPriceAccount: (state, action) => {
      state.selectedAccountExtendedData.associatedSubscriberList = action.payload;
      return state;
    },
    activateSelectPage: (state, action) => {
      state.selectCellularPackageProcess = action.payload;
      return state;
    },
    setPackagesList: (state, action) => {
      state.packagesList = action.payload;
      return state;
    },
    setDiscountedPackagesList: (state, action) => {
      state.discountedPackages = action.payload;
      return state;
    },
    setCheckBoxStatusForSelectedAccount: (state, action) => {
      state.selectedAccount.checked = action.payload;
      return state;
    },
    setAllCellularList: (state, action) => {
      state.allCellularPackagesForAccountData = action.payload;
      return state;
    },
    saveSelectedMarketPackage: (state, action) => {
      state.selectedMarketPackage = action.payload;
      state.selectCellularPackageProcess.status = packageSelectionStatus.VALIDATION;
    },
    resetThirdParty: (state, action) => {
      state.magicLinkStatus = null;
      state.magicLinkRes = null;
      state.showThirdPartyPopup = false;
    },
    changeHandler: {
      reducer(state, action) {
        state.form[action.payload.name][action.payload.name] = action.payload.value;
        state.form[action.payload.name].errors[action.payload.name] = action.payload.error;
        state.form[action.payload.name].valid = action.payload.valid;
      },
      prepare(payload) {
        const value = payload.value;
        const name = payload.name;
        const error = validateValue(payload.rule, payload.name, payload.value);
        const valid = !error;

        return {
          payload: {
            name,
            value,
            error,
            valid,
          },
        };
      },
    },
    changeCallbackHandler: {
      reducer(state, action) {
        state.callBackPhone.phone = action.payload.value;
        state.callBackPhone.errors = !action.payload.valid ? action.payload.landError : '';
        state.callBackPhone.valid = action.payload.valid;
      },
      prepare(payload) {
        const value = payload.value;
        const mobileError = validateValue(payload.rule.phone, 'phone', payload.value);
        const landError = validateValue(payload.rule.landPhone, 'phoneStationaryAccepted', payload.value);
        const valid = !mobileError || !landError;

        return {
          payload: {
            value,
            landError,
            valid,
          },
        };
      },
    },

    setSelectedForm: (state, action) => {
      state.selectedForm = action.payload;
      if (action.payload == 'phone') state.form.email = initialEmailForm;
      else state.form.phone = initialPhoneForm;
    },
    setCollaborationApproval: (state, action) => {
      state.collaborationApproval = action.payload;
      return state;
    },
    redirectToLogin: (state, action) => {}, //in use
  },
  extraReducers: {
    [getCustomerCellularList.pending]: (state, action) => {
      state.isLoading = true;
      state.error = false;
      state.errorStep = '';
      return state;
    },
    [getCustomerCellularList.fulfilled]: (state, action) => {
      state.isLoading = false;
      if (action.payload.serverError) {
        state.errorData = errors.server_error;
        state.errorReason = 'server_error';
        state.errorStep = 'getCustomerCellularList';
        state.error = true;
        return state;
      }
      state.allCellularPackagesForAccountData = action.payload.data;

      return state;
    },
    [getSelectedSubscriberDetails.pending]: (state, action) => {
      state.isLoading = true;
      state.warningConfirmed = false;
      state.errorStep = '';
      state.getSelectedSubscriberDetailsCompleted = false;
    },
    [getSelectedSubscriberDetails.fulfilled]: (state, action) => {
      state.isLoading = false;
      if (action.payload.serverError) {
        state.errorData = errors.server_error;
        state.errorReason = 'server_error';
        state.errorStep = 'getSelectedSubscriberDetails';
        state.error = true;
        return state;
      }
      state.selectedAccount = action.payload.selectedAccount;
      state.selectedAccountExtendedData = action.payload.data;
      state.getSelectedSubscriberDetailsCompleted = true;
      state.showSignCollaboration = action.payload.data.showSignCollaboration;
      state.showInvoiceByEmail = action.payload.data.showInvoiceByEmail;
      return state;
    },
    [getCurrentCellularPricePlan.pending]: (state, action) => {
      state.isLoading = true;
      state.errorStep = '';
    },
    [getCurrentCellularPricePlan.fulfilled]: (state, action) => {
      state.isLoading = false;
      if (action.payload.serverError) {
        state.errorData = errors.server_error;
        state.errorReason = 'server_error';
        state.errorStep = 'getCurrentCellularPricePlan';
        state.error = true;
        return state;
      }
      state.currentCellularPlan = action.payload.data.pp_details_desc;
      return state;
    },
    [checkIfExistsInFather.pending]: (state, action) => {
      state.isLoading = true;
      state.errorStep = '';
    },
    [checkIfExistsInFather.fulfilled]: (state, action) => {
      state.isLoading = false;
      let res = action.payload.data;
      state.magicLinkRes = magicLinkReponse(res);
      if (!res.isSuccess) {
        state.magicLinkStatus = true;
        state.showThirdPartyPopup = false;
        state.currentStep = stepEnum.FINISHMAGICLINK;
      } else {
        state.magicLinkStatus = true;
        state.showThirdPartyPopup = false;
        state.currentCellularPlan = res.extra.pricePlan.desc;
      }
      return state;
    },
    [GetOrganizationDataFromEpi.pending]: (state, action) => {
      state.isLoading = true;
      state.errorStep = '';
    },
    [GetOrganizationDataFromEpi.fulfilled]: (state, action) => {
      state.packagesList = action.payload?.cellularPackageList;
      state.magicLinkPackList = action.payload?.specialPackagesCellularList;
      state.magicLinkOrgData = action.payload;
      state.currentStep = stepEnum.FROM_MAGICKINK;
    },
    [validateAndSendMagicLink.pending]: (state, action) => {
      state.isLoading = true;
      state.errorStep = '';
    },
    [validateAndSendMagicLink.fulfilled]: (state, action) => {
      state.isLoading = false;
      let res = action.payload.data;
      state.magicLinkRes = magicLinkReponse(res);
      if (action.payload.serverError) {
        state.magicLinkStatus = false;
        state.showThirdPartyPopup = true;
      } else {
        if (res.isSuccess) {
          state.magicLinkStatus = true;
          state.currentStep = stepEnum.FINISHMAGICLINK;
          state.showThirdPartyPopup = false;
        } else {
          state.magicLinkStatus = false;
          state.showThirdPartyPopup = true;
        }
      }
      return state;
    },
    [doCallBack.pending]: (state) => {
      state.isLoading = true;
      state.callBackRequestSent = false;
      state.callbackRequest = true;
      return state;
    },
    [doCallBack.fulfilled]: (state, action) => {
      const callBackRequestFailed = action.payload.isSuccess ? false : true;
      state.isLoading = false;
      state.callBackRequestFailed = callBackRequestFailed;
      state.callBackRequestSent = action.payload.isSuccess;
      state.error = callBackRequestFailed;
      state.currentStep = stepEnum.CALL_BACK;
      state.callBackAlreadyExist = action.payload.callBackAlreadyExist;
      state.callbackRequest = false;
      return state;
    },
    [sendRequestChangingCellularPackage.pending]: (state, action) => {
      state.activateTransitionAnimation = true;
      state.completed = false;
      state.errorStep = '';
    },
    [sendRequestChangingCellularPackage.fulfilled]: (state, action) => {
      state.activateTransitionAnimation = false;
      if (action.payload.serverError) {
        state.errorData = errors.server_error;
        state.errorReason = 'server_error';
        state.errorStep = 'Change price plan';
        state.error = true;
        return state;
      }

      state.error = !action.payload.data.isSuccessed;
      state.isOwnerChanged = action.payload.data.isOwnerChanged;
      state.succeededNumbers = action.payload.data.succeededNumbers;
      state.unSucceededNumbers = action.payload.data.unSucceededNumbers;
      state.failReasonCode = action.payload.data.failReasonCode;
      if (action.payload.data.failReasonCode == 'not allowed') {
        state.familyBalance = action.payload.data.balance;
        state.familyUsed = action.payload.data.used;
      }
      state.completed = true;

      //DWH
      if (action.payload.data.isSuccessed) {
        const customerName = action.payload?.userData?.firstName + ' ' + action.payload?.userData?.lastName;
        const subscriber = action.payload?.userData?.contactNumber;
        const idNumber = action.payload?.userData?.IDNumber;

        createReportUpdateCellularPlan(
          'Success',
          state.selectedAccount?.newPackage?.offerID,
          state.allCellularPackagesForAccountData[0]?.pricePlan,
          state.selectedAccountExtendedData?.banlvl_pp_limited,
          customerName,
          subscriber,
          idNumber,
        );
      }
      return state;
    },
  },
});

export const {
  resetState,
  logoutOtp,
  mapUserPhoneNumber,
  setError,
  setAccountDataWithNewSelectedPackage,
  saveSelectedDataForFixedPriceAccount,
  handleCurrentStep,
  setWarningConfirmation,
  setHeadlineText,
  saveToHistory,
  clearHistory,
  changeHandler,
  changeCallbackHandler,
  activateSelectPage,
  setPackagesList,
  setDiscountedPackagesList,
  setCheckBoxStatusForSelectedAccount,
  setAllCellularList,
  setCollaborationApproval,
  redirectToLogin,
  saveSelectedMarketPackage,
  setSelectedForm,
  resetThirdParty,
} = changePricePlanSlice.actions;

export default changePricePlanSlice.reducer;
